<ng-container *transloco="let t; prefix: i18nScope + '.FOOTER'">
  <p>{{ t('APPLICATION_NAME', { applicationName }) }}</p>
  <p>{{ t('VERSION', { version }) }}</p>
</ng-container>
